import Flag from './icon/Flag'

export {
    Flag
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-flag-icon/components/index.js
// module id = lppc
// module chunks = 1